import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, esUrl} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';

let itemChecked2 = [];
export default class AdmSliderCompetitividadGlobal extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mscg_Titulo:"",
                mscg_Paises:"",
                mscg_Imagen:"",
                mscg_EnlaceDescarga:"",
                mscg_TopPaises:0,
                mscg_Activo:true
            },
            resourceEdit:{
                pmod_Id:0,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mscg_Id:0,
                mscg_Titulo:"",
                mscg_Paises:"",
                mscg_Imagen:"",
                mscg_EnlaceDescarga:"",
                mscg_TopPaises:0,
                mscg_Activo:true
            },
            Validacion: {
                mscg_Titulo: {
                    Error: false,                    
                },
                mscg_EnlaceDescarga: {
                    Error: false,                    
                },
                mscg_Imagen: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mscg_Titulo: {
                    Error: false,                    
                },
                mscg_EnlaceDescarga: {
                    Error: false,                    
                },
                mscg_Imagen: {
                    Error: false,                    
                }
            },
            resourcePaises:{
                filtroPaises:"",
                paises:[],
                paisesIds:[]
            },
            itemChecked2:[],
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: []
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
    }

    onCheck = (item, id, e) => 
    {
        const target = e.target;
        itemChecked2[e.target.name] = !e.target.checked?false:true;

        let resourcePaises = this.state.resourcePaises;
        let paisesSeleccionadosObj = resourcePaises.paisesIds;
        if(target.type === 'checkbox' )
        {
            if(e.target.checked){
                let obj = {
                    id: id,
                    nombre: item
                }
                paisesSeleccionadosObj[id] = obj;
            }else{
                paisesSeleccionadosObj[id] = null;
            }
        }
        resourcePaises.paisesIds = paisesSeleccionadosObj;
        
        setTimeout(() => {
            this.setState({itemChecked2, resourcePaises:resourcePaises});
        },100)
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.searchPaises();
        }
    }

    searchPaises = () => {

        let resourcePaises = this.state.resourcePaises;
        let textoFilter = resourcePaises.filtroPaises;

        if(textoFilter === '')
        {   
            resourcePaises.paises = [];    
            this.setState({resourcePaises:resourcePaises});
            return;
        }

        const url = `${API_URL}GeneralUX/ObtenerPaisesNombre/${textoFilter}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            resourcePaises.paises = data.result;
            this.setState({resourcePaises:resourcePaises});
        })
        .catch(error => {
            console.log('Error de comunicación');   
        });
    }

    PaisesSeleccionados()
    {
        let paisesNombre = [];

        this.state.resourcePaises.paisesIds.forEach(pais => {
            if(pais != null){
                paisesNombre.push(pais.nombre);
            }  
        });

        return paisesNombre.length > 0 ? paisesNombre.join(',') : '';
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if(target.name == 'filtroPaises'){
            let copyResource = this.state.resourcePaises;
            copyResource[target.name] = value;

            this.setState({
                resourcePaises: copyResource
            });

        }else{

            let copyResource = this.state.resource;
            copyResource[target.name] = value;

            let validaciones = this.state.Validacion;

            validaciones[target.name] = {
                Error: false,                    
            }

            this.setState({
                resource: copyResource,
                Validacion: validaciones
            }); 
        } 
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resourceEdit: copyResource,
            ValidacionEdit: validaciones
        });  
    }

    storeModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mscg_Titulo == '') {              
            newState.Validacion.mscg_Titulo = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.mscg_EnlaceDescarga == '') {              
            newState.Validacion.mscg_EnlaceDescarga = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.mscg_EnlaceDescarga !== '' && !esUrl(newState.resource.mscg_EnlaceDescarga)) {  
            newState.Validacion.mscg_EnlaceDescarga = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        let paises_id = [];

        this.state.resourcePaises.paisesIds.forEach(pais => {
            if(pais != null){
                paises_id.push(pais.id);
            }  
        });

        const url = `${API_URL}ModuloSliderCompetitividadGlobalUX/`;
        var dataForm = this.state.resource;
        dataForm.mscg_Paises = paises_id.join(",");
        dataForm = updateValueInJson(dataForm,'mscg_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;

                stateResponse.resource.mscg_Titulo = '';
                stateResponse.resource.mscg_Paises = '';
                stateResponse.resource.mscg_Imagen = '';
                stateResponse.resource.mscg_EnlaceDescarga = '';
                stateResponse.resource.mscg_TopPaises = 0;


                stateResponse.resource.pmod_Id = result.pmod_Id;

                document.getElementById("pweb_Id").selectedIndex = 0;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    updateModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mscg_Titulo == '') {              
            newState.ValidacionEdit.mscg_Titulo = {Error: true};
            newState.hasError = true;
        }

        if (newState.resourceEdit.mscg_EnlaceDescarga == '') {              
            newState.ValidacionEdit.mscg_EnlaceDescarga = {Error: true};
            newState.hasError = true;
        }

        if (newState.resourceEdit.mscg_EnlaceDescarga !== '' && !esUrl(newState.resourceEdit.mscg_EnlaceDescarga)) {  
            newState.ValidacionEdit.mscg_EnlaceDescarga = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        let paises_id = [];

        this.state.resourcePaises.paisesIds.forEach(pais => {
            if(pais != null){
                paises_id.push(pais.id);
            }  
        });

        const url = `${API_URL}ModuloSliderCompetitividadGlobalUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm.mscg_Paises = paises_id.join(",");
        dataForm = updateValueInJson(dataForm,'mscg_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    closeModulo = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;
        
        let resourceEdit = this.state.resourceEdit;
        resourceEdit.mscg_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});

        this.props.callback(true);
        
    }

    loadModulo = (pmod_Id) => 
    {
        const url = `${API_URL}ModuloSliderCompetitividadGlobalUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            let paisesIdString = data.result.paisesIdNombre;
            let paisesIds = [];
            if(paisesIdString != ''){

                let paisesIdArray = paisesIdString.split(',');

                if(paisesIdArray.length > 0)
                {
                    paisesIdArray.forEach(idnombre => {

                        idnombre = idnombre.trim();

                        if(idnombre != ''){
                            let arrayString = idnombre.split('|');
                            
                            itemChecked2["check_" + arrayString[0]] = true;
                            paisesIds[arrayString[0]] = {
                                id: arrayString[0],
                                nombre: arrayString[1]
                            }
                        }
                    });
                }
            }

            let resourcePaises = {
                filtroPaises:"",
                paises:[],
                paisesIds:paisesIds
            }
            
            this.setState({ resourceEdit: data.result, resourcePaises:resourcePaises, itemChecked2:itemChecked2, response: data, error: data.Error });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps){

        let mweb = 40;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadModulo(resource.pmod_Id);
            }, 100); 
        }
      } 

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeModulo()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">

                        {
                            this.state.resourceEdit.mscg_Id > 0 ?
                            <React.Fragment>
                            <div className="containerFormCreation divModuloPopup_Panel">
                                {
                                    this.state.added ?
                                    <div className="txtFile x-1">
                                        <strong style={{
                                            display: "block",
                                            textAlign:"center",
                                            color: "#008000a3"
                                        }}> Registro actualizado satisfactoriamente!!</strong>
                                    </div> : null
                                }
                                
                                <div className="textareaResumen x-1">
                                    <input type="text" placeholder="Título" 
                                    value={this.state.resourceEdit.mscg_Titulo} 
                                    name="mscg_Titulo"  
                                    className={this.state.ValidacionEdit.mscg_Titulo.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit} 
                                    maxLength={255} />
                                </div>

                                <div className="textareaResumen x-1">
                                    <input type="text" placeholder="Enlace de Descarga" 
                                    value={this.state.resourceEdit.mscg_EnlaceDescarga} 
                                    name="mscg_EnlaceDescarga"  
                                    className={this.state.ValidacionEdit.mscg_EnlaceDescarga.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit} 
                                    maxLength={255} />
                                </div>

                                <div className="textareaResumen x-1">
                                    <input type="text" placeholder="Top Paises" 
                                    value={this.state.resourceEdit.mscg_TopPaises} 
                                    name="mscg_TopPaises"  
                                    onChange={this.handleInputChangeEdit} 
                                    maxLength={4} />
                                </div>

                                <div className="txtSelect-Radio">
                                    <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Seleccione paises:</b></p>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Buscar..." 
                                        name="filtroPaises" 
                                        value={this.state.resourcePaises.filtroPaises}
                                        classname="buscadorItemsPaises" 
                                        onKeyDown={this._handleKeyDown}
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div style={{height: 250, overflowX: 'hidden', overflowY: 'scroll', border: '1px solid #DBDCDB', borderRadius: 4, boxShadow: 'inset 1px 1px 2px 0px rgb(228, 228, 228)', paddingLeft: 10, paddingTop: 10, paddingBottom: 10}}>
                                        {
                                            this.state.resourcePaises.paises.length > 0 ?
                                            this.state.resourcePaises.paises.map((linea) => (
                                                <div className="inputRadio" style={{width: '100%', display: 'block'}}>
                                                    <input type="checkbox" 
                                                    style={{WebkitAppearance: 'checkbox'}} 
                                                    name={"check_" + linea.id} 
                                                    checked={this.state.itemChecked2["check_" + linea.id]}  
                                                    onClick={(event) => this.onCheck(linea.nombre, linea.id, event)}/>
                                                    <label>{linea.nombre}</label>
                                                </div> 
                                            )) : null
                                        }                           
                                    </div>
                                </div>

                                <div className="textareaResumen x-1">
                                    <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Paises seleccionadas:</b></p>
                                    <textarea placeholder="Paises Seleccionadas" value={this.PaisesSeleccionados()} style={{height:"100px"}}/>
                                </div>

                                

                                <div className="divModulo_Seo">
                                    <h2><strong>Configuración de modulo</strong></h2>
                                    <div className="divWrapperModulo_Seo">
                                        
                                        <div className="txtFile x-2">
                                            <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resourceEdit.pmod_ClaseAncla}  
                                            onChange={this.handleInputChangeEdit}/>
                                        </div>	

                                        <div className="txtFile x-1">
                                            <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                            onChange={this.handleInputChangeEdit} >
                                                <option value="0">Seleccionar Perfil</option>
                                                {
                                                    this.state.perfiles.length > 0 ?
                                                    this.state.perfiles.map((perfil) => (
                                                        <option value={perfil.id} selected={(this.state.resourceEdit.pmod_Pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                                    ))
                                                    : null
                                                }
                                            </select>                        
                                        </div>

                                        <div className="txtFile x-1 ocultarcms">
                                            <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                            onChange={this.handleInputChangeEdit} >
                                                <option value="0">Seleccionar Sector</option>
                                                {
                                                    this.state.sectores.length > 0 ?
                                                    this.state.sectores.map((sector) => (
                                                        <option value={sector.id} selected={(this.state.resourceEdit.pmod_Sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                                    ))
                                                    : null
                                                }
                                            </select>                        
                                        </div>
                                        
                                    </div>
                                </div>



                            </div>
                            <div>
                                <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updateModulo(e)}>ACTUALIZAR</a>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">

                                    
                                    <div className="textareaResumen x-1">
                                        <input type="text" placeholder="Título" 
                                        value={this.state.resource.mscg_Titulo} 
                                        name="mscg_Titulo"  
                                        className={this.state.Validacion.mscg_Titulo.Error ? "error" : ""}
                                        onChange={this.handleInputChange} 
                                        maxLength={300} />
                                    </div>

                                    <div className="textareaResumen x-1">
                                    <input type="text" placeholder="Enlace de Descarga" 
                                    value={this.state.resource.mscg_EnlaceDescarga} 
                                    name="mscg_EnlaceDescarga"  
                                    className={this.state.Validacion.mscg_EnlaceDescarga.Error ? "error" : ""}
                                    onChange={this.handleInputChange} 
                                    maxLength={255} />
                                </div>

                                <div className="textareaResumen x-1">
                                    <input type="text" placeholder="Top Paises" 
                                    value={this.state.resource.mscg_TopPaises} 
                                    name="mscg_TopPaises"  
                                    onChange={this.handleInputChange} 
                                    maxLength={4} />
                                </div>

                                <div className="txtSelect-Radio">
                                    <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Seleccione paises:</b></p>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Buscar..." 
                                        name="filtroPaises" 
                                        value={this.state.resourcePaises.filtroPaises}
                                        classname="buscadorItemsPaises" 
                                        onKeyDown={this._handleKeyDown}
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div style={{height: 250, overflowX: 'hidden', overflowY: 'scroll', border: '1px solid #DBDCDB', borderRadius: 4, boxShadow: 'inset 1px 1px 2px 0px rgb(228, 228, 228)', paddingLeft: 10, paddingTop: 10, paddingBottom: 10}}>
                                        {
                                            this.state.resourcePaises.paises.length > 0 ?
                                            this.state.resourcePaises.paises.map((linea) => (
                                                <div className="inputRadio" style={{width: '100%', display: 'block'}}>
                                                    <input type="checkbox" 
                                                    style={{WebkitAppearance: 'checkbox'}} 
                                                    name={"check_" + linea.id} 
                                                    checked={this.state.itemChecked2["check_" + linea.id]}  
                                                    onClick={(event) => this.onCheck(linea.nombre, linea.id, event)}/>
                                                    <label>{linea.nombre}</label>
                                                </div> 
                                            )) : null
                                        }                           
                                    </div>
                                </div>

                                <div className="textareaResumen x-1">
                                    <p style={{fontFamily: 'OpenSans', fontSize: 13}}><b>Paises seleccionadas:</b></p>
                                    <textarea placeholder="Paises Seleccionadas" value={this.PaisesSeleccionados()} style={{height:"100px"}}/>
                                </div>


                                    <div className="divModulo_Seo">
                                        <h2><strong>Configuración de modulo</strong></h2>
                                        <div className="divWrapperModulo_Seo">
                                            
                                            <div className="txtFile x-2">
                                                <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resource.pmod_ClaseAncla}  
                                                onChange={this.handleInputChange}/>
                                            </div>	

                                            <div className="txtFile x-1">
                                                <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Perfil</option>
                                                    {
                                                        this.state.perfiles.length > 0 ?
                                                        this.state.perfiles.map((perfil) => (
                                                            <option value={perfil.id} key={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>

                                            <div className="txtFile x-1 ocultarcms">
                                                <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Sector</option>
                                                    {
                                                        this.state.sectores.length > 0 ?
                                                        this.state.sectores.map((sector) => (
                                                            <option value={sector.id} key={sector.id}>{sector.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>
                                            
                                        </div>
                                    </div>

                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storeModulo(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                        }
                        
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}